import { SimpleLiquiditySource } from './simple-liquidity-source';
import { EthUnitUtil } from '@31third/common';
import { BaseEntityModel } from './base-entity-model';
import { ChainTokenTradeableCategory } from '../enum';
import { Trade } from './trade';
import { TenderlySimulation } from './tenderly-simulation';

export class ChainTokenCheckResult implements BaseEntityModel {
  id: string | undefined;
  creationDate: Date;
  modificationDate: Date;
  liquiditySource: SimpleLiquiditySource;
  isLiquiditySourceEnabled: boolean;
  trade: Trade;
  tenderlySimulation: TenderlySimulation;

  public isTradeable(): boolean {
    return this.tenderlySimulation && !this.tenderlySimulation.isTradeFailed();
  }

  public getTradeableCategory(): ChainTokenTradeableCategory {
    if (!this.isTradeable()) {
      return ChainTokenTradeableCategory.NOT_TRADEABLE;
    }

    return this.trade.estimatedPriceImpact > 0.01
      ? ChainTokenTradeableCategory.BAD_LIQUIDITY
      : ChainTokenTradeableCategory.TRADEABLE;
  }

  public toString(): string {
    const enabledString = this.isLiquiditySourceEnabled
      ? 'Enabled'
      : 'Not enabled';

    let tradeString = '\n  No trade found';
    if (this.trade) {
      const fromAmount = EthUnitUtil.convertBigIntToBigDecimal(
        this.trade.fromAmount,
      )
        .round(4)
        .getValue();

      tradeString = `
  Trade: ${fromAmount} ${this.trade?.from?.symbol}>${this.trade?.to?.symbol}
  From Value: ${this.trade?.fromValueInUsd}
  To Value:   ${this.trade?.toValueInUsd}
  Estimated price impact: ${this.trade?.estimatedPriceImpact}`;
    }

    let simString = '\n  No simulation done';
    if (this.tenderlySimulation) {
      simString = `
  Simulation status: ${this.tenderlySimulation.status}
  Simulation url: ${this.tenderlySimulation.url}`;
    }

    return `LiquiditySource: ${this.liquiditySource?.readableName} (${enabledString})${tradeString}${simString}`;
  }
}
